import { ParamIds, Places } from 'src/Constants'
import IntegracaoMonitoramentoKeys from '../integracao-monitoramento.keys'

export class IntegracaoMonitoramentoFormKeys extends IntegracaoMonitoramentoKeys {
    get place() {
        return Places.mcIntegracaoMonitoramentoForm
    }

    get monitoramentoId() {
        return this._intent.getParameterAsNumber(ParamIds.mcMonitoramentoFormId)
    }

    set monitoramentoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcMonitoramentoFormId, value)
    }
}
